import React from "react";
import UserAvatar from "@/lib/profile/user-avatar";
import { useStytchUser } from "@stytch/react";

const UserDetails = () => {
  const { user } = useStytchUser();

  return (
    <div className="flex items-center space-x-2 overflow-x-hidden">
      <UserAvatar />
      <div className="space-y-1 overflow-x-hidden">
        <h1 className="text-base font-black leading-none uppercase">
          {user?.name.first_name}!
        </h1>
        <p className="text-xs leading-none truncate py-0.5">
          {user?.emails[0].email}
        </p>
      </div>
    </div>
  );
};

export default UserDetails;
